import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';

type StageType =
  | 'INIT_BUTTON'
  | 'USER_INFO'
  | 'SELECT_PAYMENT'
  | 'PAYMENT_SUCCESS'
  | 'PAYMENT_FAILURE';

interface PaymentStageContent {
  currentStage: StageType;
  setCurrentStage: (stage: StageType) => void;
  selectedProductNum: number | undefined;
  setSelectedProductNum: (num: number) => void;
}

export const PaymentStageContext = createContext<PaymentStageContent>({
  currentStage: 'INIT_BUTTON',
  setCurrentStage: () => {},
  selectedProductNum: 0,
  setSelectedProductNum: () => {},
});

export const PaymentStageProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [currentStage, setCurrentStage] = useState<StageType>('INIT_BUTTON');
  const [selectedProductNum, setSelectedProductNum] = useState<
    number | undefined
  >(undefined);

  const value = {
    currentStage,
    setCurrentStage,
    selectedProductNum,
    setSelectedProductNum,
  };

  return (
    <PaymentStageContext.Provider value={value}>
      {children}
    </PaymentStageContext.Provider>
  );
};

export const usePaymentStageContext = () => useContext(PaymentStageContext);
